/**!
 * Created by Leonardo Cheslacki on 23/07/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import Big from 'big.js';

import HelpersController from './HelpersController';

import {HelpersPin, HelpersForm, HelpersKeyboard} from './';
import {StagesPaginates} from "./stages";
import {GamesGenius} from "./games";

let _this = {};

/**
 *
 */
class HelpersAllTap extends HelpersController {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.props = props;
        _this = this;

        const {window, window: {location, jQuery, createjs, document}, _TITLE_, _LOCATION_, _SOURCE_} = this.props;

        this.$jQuery = jQuery;
        this.$createJs = createjs;
        this.$page_default = this._void;
        this.$page_before = this._void;

        this.$StagesPaginates = StagesPaginates(this);

        this.$GamesGenius = GamesGenius(this);

        this.$HelpersKeyboard = HelpersKeyboard(this);

        this.state = {
            title: _TITLE_,
            uri: this.toUri(((_LOCATION_ !== null) ? _LOCATION_ : location), _SOURCE_),
            _this_index: {},
            marker_name: null
        };

        this.setAppCssIFrame(document, 'index');
    };

    /**
     *
     * @param document
     * @param name
     */
    setAppCssIFrame = (document, name) => {
        const
            {uri} = this.state,
            iframe = this.$jQuery(document).find(`#load_iframe_${name}`),
            attributes = {media: 'all', type: 'text/css', rel: 'stylesheet'};

        const appendToHead = (callback) => {
            const head = iframe.contents().find('head');
            if (typeof (head) !== 'undefined' && Boolean(head.length)) {
                this.$jQuery('<link/>', {...attributes, href: `${uri}/public/css/package.min.css`}).appendTo(head);
                this.$jQuery('<link/>', {...attributes, href: `${uri}/public/css/app.min.css`}).appendTo(head);
                (typeof (callback) === 'function') && callback(true);
            }
        };

        iframe.on('load', () => {
            appendToHead();
        });

        const loadController = () => {
            appendToHead(() => {
                this.$createJs.Ticker.removeEventListener('tick', loadController);
            });
        };

        this.$createJs.Ticker.addEventListener('tick', loadController);
    };

    /**
     *
     * @param document
     */
    setTitle = (document) => {
        const {title} = this.state;
        this.isElement(document) && (document.title = title);
    };

    /**
     *
     * @param object
     */
    onLoad = (object) => {
        const {
            full_screen,
            library,
            // document
        } = object;
        full_screen && this.fullScreen();
        this.setState({...this.state, ...library});
        this.setTitle(document);
    };

    fullScreen = () => {
        if (this.$jQuery.isFunction(this.$jQuery.fn.confirm)) {
            const
                {window: {document}} = this.props,
                {uri} = this.state;

            this.$jQuery.confirm({
                title: `<img class="img-medium" src="${uri}/public/images/icons/favicon-white-128.png" alt="logo-confirm"/>`,
                content: false,
                theme: 'supervan',
                closeIcon: false,
                animation: 'scale',
                draggable: false,
                buttons: {
                    confirm: {
                        text: this.$laguage.jQueryConfirm.text_confirm,
                        btnClass: 'btn-default',
                        action: () => {
                            this.openFullScreen(document.documentElement);
                        }
                    },
                    cancel: {
                        text: this.$laguage.jQueryConfirm.text_cancel,
                        btnClass: 'btn-default',
                        action: this._void
                    }
                }
            });
        }
    };

    /**
     *
     * @param _this_current
     * @param name
     * @param callback
     */
    effectFadeIn = (_this_current, name, callback = null) => {
        const
            {alpha_min, alpha_plus, alpha_max} = this.props,
            plus = (new Big(alpha_plus)),
            max = (new Big(alpha_max));

        _this_current[name].alpha = (new Big(alpha_min)).toNumber();

        const execute = () => {
            let alpha = (new Big(_this_current[name].alpha)).plus(plus).round(1, Big.roundUp);
            _this_current[name].alpha = alpha.toNumber();
            if (alpha.gte(max)) {
                _this_current.removeEventListener('tick', execute);
                (typeof (callback) === 'function') && callback(true);
            }
        };

        _this_current.addEventListener('tick', execute);
    };

    /**
     *
     * @param xml
     * @returns {{}}
     */
    xmlToJson = (xml) => {
        let object = {};

        if (this.isNodeElement(xml) && this.isObjectIf(xml.attributes)) {
            let attributes = xml.attributes;
            object['@attributes'] = {};

            this.recursiveSyncMap(attributes, 0, attributes.length, (item, next) => {
                object['@attributes'][item.nodeName] = item.value;
                next(true);
            });
        } else if (this.isNodeText(xml)) {
            object = xml.nodeValue;
        }

        if (xml.hasChildNodes()) {
            this.recursiveSyncMap(xml.childNodes, 0, xml.childNodes.length, (item, next) => {
                const {nodeName} = item;

                if (!this.inObject(object, nodeName)) {
                    object[nodeName] = this.xmlToJson(item);
                } else {
                    if (!this.inFunction(object[nodeName], 'push')) {

                        let old = object[nodeName];
                        object[nodeName] = [];
                        object[nodeName].push(old);
                    }
                    object[nodeName].push(this.xmlToJson(item));
                }
                next(true);
            });
        }

        return object;
    };

    /**
     *
     * @param uri
     * @param callback
     */
    getXml = (uri, callback) => {
        let helpersForm = (new HelpersForm(this)({target: {method: 'GET', action: uri}, type: 'xml'})());

        helpersForm.$objectResponse.done = (response) => {
            callback(this.xmlToJson(response));
        };

        helpersForm.$objectResponse.fail = (response) => {
            console.log(response);
        };

        helpersForm.$objectResponse.always = this._void;

        helpersForm.submit();
    };

    /**
     *
     * @param uri
     * @param data
     * @param objectResponse
     */
    postForm = (uri, data, objectResponse) => {
        const {ajax_setup_headers} = this.props;

        let helpersForm = (new HelpersForm(this)({target: {method: 'POST', action: uri}, type: 'json'})());

        helpersForm.$objectResponse = objectResponse;

        helpersForm.setHeaders(ajax_setup_headers);

        helpersForm.setToJsonData(data, helpersForm.submit);
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openExternal = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            window.open(src, '_blank', 'toolbar=0, location=0, menubar=0');
            (typeof (callback) === 'function') && callback(true);
        });
    };

    /**
     *
     * @param callback
     */
    closeVideo = (callback) => {
        this.$jQuery('.close-content-video').on('click', () => {
            let content_video = this.$jQuery('.content-video');

            if (content_video.hasClass('animate__fadeIn')) {
                content_video.removeClass('animate__fadeIn');
            }

            content_video.on('animationend', () => {
                if (content_video.hasClass('animate__fadeOut')) {
                    (typeof (callback) === 'function') ? content_video.hide(callback) : content_video.hide();
                    content_video.find('.video-play').trigger('pause').trigger('load');
                    content_video.removeClass('animate__fadeIn animate__fadeOut');
                }
            });

            content_video.addClass('animate__fadeOut');
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openVideo = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            //this.$jQuery('#load_iframe_index').attr('src', '');
            let
                content_video = this.$jQuery('.content-video'),
                player = content_video.find('.video-play');

            !content_video.hasClass('animate__fadeIn') && content_video.addClass('animate__fadeIn');
            content_video.find('.video-play source').attr('src', src);
            player.off('ended.player');
            player.on('ended.player', () => {
                this.$jQuery('.close-content-video').trigger('click');
            });
            player.trigger('load').trigger('play');
            (typeof (callback) === 'function') ? content_video.show(callback) : content_video.show();
        });
    };

    /**
     *
     * @param callback
     */
    closeTour = (callback) => {
        this.$jQuery('.close-content-tour').on('click', () => {
            let content_tour = this.$jQuery('.content-tour');

            if (content_tour.hasClass('animate__fadeIn')) {
                content_tour.removeClass('animate__fadeIn');
            }

            content_tour.addClass('animate__fadeOut');

            content_tour.on('animationend', () => {
                if (content_tour.hasClass('animate__fadeOut')) {
                    (typeof (callback) === 'function') ? content_tour.hide(callback) : content_tour.hide();
                    content_tour.removeClass('animate__fadeIn animate__fadeOut');
                    content_tour.find('#load_iframe_tour').attr('src', '');
                }
            });
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openTour = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            //this.$jQuery('#load_iframe_index').attr('src', '');
            let content_tour = this.$jQuery('.content-tour');
            !content_tour.hasClass('animate__fadeIn') && content_tour.addClass('animate__fadeIn');
            content_tour.find('#load_iframe_tour').attr('src', src);
            (typeof (callback) === 'function') ? content_tour.show(callback) : content_tour.show();
        });
    };

    /**
     *
     * @param array
     * @param before
     */
    createMenu = (array, before = null) => {
        const
            {marker_type} = this.props,
            {
                uri,
                _this_index,
                _this_index: {
                    occ_logo_large,
                    occ_logo_medium,
                    occ_logo_small,
                    occ_background,
                    occ_background_effect,
                    occ_background_dynamic
                }
            } = this.state;

        let animate = null, temp = null;

        if (!this.isEmpty(before)) {
            _this_index.visible = false;
            this.$jQuery(window.document).find('.content-paginate').attr({style: 'height: 100%;'});
        }

        const goToAndAnimate = (name) => {
            const
                {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index,
                {marker_name} = this.state;

            if (marker_type === 'arrow') {
                occ_menu_marker.gotoAndStop(name);
                occ_animate.play();
            } else if ((marker_type === 'strip') && (marker_name !== name)) {
                this.setStates({marker_name: name}, () => {
                    occ_animate.gotoAndPlay('complete');
                });
            }

            if (!this.isEmpty(before)) {
                let
                    label = (name !== before),
                    content_paginate = this.$jQuery(window.document).find('.content-paginate');

                _this_index.visible = label;

                if (label) {
                    content_paginate.removeAttr('style');
                } else {
                    content_paginate.attr({style: 'height: 100%;'});
                }
            }
        };

        if (marker_type === 'strip') {
            this.on('animate_strip', (event) => {
                const
                    {marker_name} = this.state,
                    {end} = event,
                    {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index;

                if (end) {
                    occ_menu_marker.gotoAndStop(marker_name);
                    occ_animate.gotoAndPlay('start');
                }
            });
        }

        this.on('animate_end', (event) => {
            const {complete, end, object} = event;
            if (complete) {
                animate = object;
            } else if (end && this.isFunction(temp)) {
                temp();
                animate = null;
                temp = null;
            }
        });

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let btn_name = this.verifyField(item, 'button', false, null);

                if (this.isEmpty(btn_name)) {
                    let array_name = name.split('-');
                    btn_name = (this.isArrayIf(array_name) && (array_name.length > 1)) ? `btn_${array_name.join('_')}` : `btn_${array_name.join()}`;
                }

                if (this.verifyField(item, 'occ_external')) {
                    this.openExternal(_this_index[btn_name], this.verifyField(item, 'src', false, ''));
                } else if (this.verifyField(item, 'occ_video')) {
                    this.openVideo(_this_index[btn_name], this.verifyField(item, 'src', false, ''), () => {
                        goToAndAnimate(name);
                    });

                    this.closeVideo(() => {
                        const {occ_menu_marker: {currentLabel}} = _this_index;
                        (currentLabel === 'video') && this.$page_default();
                    });
                } else if (this.verifyField(item, 'occ_tour')) {
                    this.openTour(_this_index[btn_name], this.verifyField(item, 'src', false, ''), () => {
                        goToAndAnimate(name);
                    });

                    this.closeTour(() => {
                        const {occ_menu_marker: {currentLabel}} = _this_index;
                        (currentLabel === 'tour') && this.$page_default();
                    });
                } else {
                    let execute = () => {
                        this.$jQuery('#load_iframe_index').attr('src', `${uri}/src/${name}/${name}.html`);
                        occ_logo_large && (occ_logo_large.visible = this.verifyField(item, 'occ_logo_large'));
                        occ_logo_medium && (occ_logo_medium.visible = this.verifyField(item, 'occ_logo_medium'));
                        occ_logo_small && (occ_logo_small.visible = this.verifyField(item, 'occ_logo_small'));
                        occ_background && (occ_background.visible = this.verifyField(item, 'occ_background'));
                        occ_background_dynamic && (occ_background_dynamic.visible = this.verifyField(item, 'occ_background_dynamic'));

                        if (occ_background_effect) {
                            let occ_background_effect_visible = this.verifyField(item, 'occ_background_effect');
                            occ_background_effect.visible = occ_background_effect_visible;
                            occ_background_effect_visible && occ_background_effect.gotoAndPlay(0);
                        }

                        occ_background_dynamic && occ_background_dynamic.gotoAndStop(name);
                        goToAndAnimate(name);
                    };

                    let page = () => {
                        if (this.isObjectIf(animate)) {
                            animate.gotoAndPlay('complete');
                            temp = execute;
                        } else {
                            execute();
                        }
                    };

                    if (this.verifyField(item, 'page_before')) {
                        this.$page_before = page;
                    } else if (this.verifyField(item, 'page_default')) {
                        this.setState({...this.state, marker_name: name});
                        this.$page_default = page;
                    }

                    this.$jQuery(_this_index[btn_name]).on('click', page);
                }
                next(true);
            } else {
                stop(true);
            }
        });
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, helpersPin: (HelpersPin|*), pin, setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, setNumber(*, *, *, null=, null=, null=, null=): void, object: null}|null}
     */
    clonePin = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(),

            /**
             *
             * @returns {null}
             */
            get pin() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pin(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin} = _this_current;
                this.pin = content_pin.clone();
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color = null, font = null, size = null, weight = null) {
                const {occ_pin_number} = this.object;
                this.helpersPin.setNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin_animate} = this.object;
                this.helpersPin.setAnimate(occ_pin_animate, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, helpersPin: (HelpersPin|*), setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, pinText, setNumber(*, *, *, null=, null=, null=, null=): void, object: null, setText(*, *, *, *, *): void}|null}
     */
    clonePinText = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(),

            /**
             *
             * @returns {null}
             */
            get pinText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pinText(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin_text} = _this_current;
                this.pinText = content_pin_text.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setText(string, color, font, size, weight) {
                const {occ_text} = this.object;
                this.helpersPin.setText(occ_text, string, color, font, size, weight);
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color = null, font = null, size = null, weight = null) {
                const {occ_pin: {occ_pin_number}} = this.object;
                this.helpersPin.setNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const
                    {occ_pin} = this.object,
                    occ_color = _this.verifyField(occ_pin, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin: {occ_pin_animate}} = this.object;
                this.helpersPin.setAnimate(occ_pin_animate, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param current
     * @param name
     * @param single
     * @param library
     */
    createMarkers = (current, name, single, library = null) => {
        let current_name = (this.isEmpty(single) ? `${name}` : `${current}`);

        const
            {
                content_text_pins,
                pin_default_color_enabled,
                pin_default_color_disabled,
                pin_round_default_color,
                pin_text_default_color,
                pin_number_default_color,
                //pin_text_default_x,
                pin_text_default_y,
                pin_text_default_font,
                pin_text_default_size,
                pin_text_default_weight
            } = this.props,
            {uri} = this.state,
            _this_current = this.state[`_this_${current_name}`],
            {properties} = this.state[`_this_${(!this.isEmpty(library) ? library : current_name)}_library`],
            {
                currentFrame,
                occ_modal,
                occ_modal_background,
                btn_close
            } = _this_current;

        let
            current_frame = this.padWithLeadingZeros(currentFrame, 2),
            content_plant = _this_current[`occ_frame_${current_frame}`],
            frame = content_text_pins[`frame_${current_frame}`],
            frame_keys = null;

        content_plant.occ_pins.removeAllChildren();

        if (this.isObjectIf(frame)) {
            frame_keys = Object.keys(frame);
            for (const property in frame) {
                _this_current[`content_text_${current_frame}${property}`].removeAllChildren();
            }
        }

        this.getXml(`./src/${(!this.isEmpty(library) ? `${library}/` : ``)}${(!this.isEmpty(current) ? `${current}` : ``)}${(this.isEmpty(single) ? `/${current_name}` : ``)}/${name}.xml`, (response) => {
            let
                bitmap = null,
                children_temp = null,
                array = this.verifyField(response, 'products.product', false, []),
                pin_default_color = pin_default_color_disabled;

            /**
             * Clone pin text
             */
            let
                //X = 0;
                Y = 0,
                count = 0,
                letter = 0,
                total = 0;

            this.recursiveSyncMap(array, 0, array.length, (item, next) => {
                if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                    total = this.verifyField(frame, `${frame_keys[letter]}`, false, false);
                }

                const pin = this.clonePin(this), pin_text = this.clonePinText(this);

                let
                    /**
                     * Clone pin text
                     */
                    _id = this.verifyField(item, '@attributes.id', false, 0),
                    image = this.verifyField(item, 'src.#text', false, 0);

                image && (pin_default_color = pin_default_color_enabled);

                /**
                 * Clone pin
                 */
                pin.clone(current_name);
                pin.setNumber(this.verifyField(item, 'title.#text', false, 0), null, 12.2, pin_number_default_color);
                pin.setColor(this.verifyField(item, 'tintColor.#text', false, pin_default_color), 'occ_pin_color');
                pin.setColor(pin_round_default_color, 'occ_pin_round');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                pin.setCoordinate(this.verifyField(item, 'x.#text', false, 0), this.verifyField(item, 'y.#text', false, 0));

                /**
                 * Clone pin text
                 */
                pin_text.clone(current_name);

                if (!this.isIdCompound(_id)) {
                    let text = this.verifyField(item, 'text.#text');

                    /**
                     * Clone pin text
                     */
                    pin_text.setText(text, pin_text_default_color, pin_text_default_font, pin_text_default_size, pin_text_default_weight);
                    pin_text.setNumber(this.verifyField(item, 'title.#text', false, 0), null, -7.2, pin_number_default_color);
                    pin_text.setColor(this.verifyField(item, 'tintColor.#text', false, pin_default_color), 'occ_pin_color');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_round');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                    pin_text.setCoordinate(0, Y);
                    //pin_text.setCoordinate(X, 10);
                    //let count = ((text.length * 9) + 37);
                    //X += count < pin_text_default_x ? pin_text_default_x : count;
                }

                if (image) {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(true);
                    pin.setAction(true, 'pointer', `${uri}/${image}`);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(true);
                        pin_text.setAction(true, 'pointer', `${uri}/${image}`);
                    }

                    /**
                     *
                     * @param event
                     */
                    let execute = (event) => {
                        const image = (new Image());

                        image.addEventListener('load', () => {
                            occ_modal.x = (new Big(properties.width)).minus(new Big(_this_current.getBounds().width)).div(_this.$controller.big_2).round(1, Big.roundUp).toNumber();
                            occ_modal.y = (new Big(properties.height)).minus(new Big(_this_current.getBounds().height)).div(_this.$controller.big_2).round(1, Big.roundUp).toNumber();
                        });

                        image.src = event.currentTarget.uri;

                        bitmap && occ_modal.removeChild(bitmap);
                        bitmap = (new this.$createJs.Bitmap(image));
                        bitmap.scaleX = this.verifyField(item, 'scaleX.#text', false, 0);
                        bitmap.scaleY = this.verifyField(item, 'scaleY.#text', false, 0);
                        occ_modal.addChild(bitmap);

                        // Create legend for image
                        // let text = new this.$createJs.Text("30 TEST", "30px 'Montserrat'", "#FFFFFF");
                        //  text.textAlign = "right";
                        //  text.lineHeight = 46;
                        //  text.setTransform(1020.7,522);
                        //
                        //  let  shape = new this.$createJs.Shape();
                        //  shape.graphics.beginFill("#999999").beginStroke().moveTo(-148,25).lineTo(-148,-25).lineTo(148.1,-25).lineTo(148.1,25).closePath();
                        //  shape.setTransform(960,540);
                        //
                        //  //shape = shape.addChild(text);
                        //
                        //  occ_modal.addChild(shape);
                        //  occ_modal.addChild(text);

                        children_temp = _this_current.children;

                        _this_current.children = _this_current.children.filter((value) => {
                            return (value.name === 'btn_close' || value.name === 'occ_modal' || value.name === 'occ_modal_background');
                        });

                        occ_modal_background.visible = true;

                        btn_close.visible = true;

                        this.effectFadeIn(_this_current, 'occ_modal');
                    };

                    /**
                     * Clone pin
                     */
                    this.$jQuery(pin.pin).on('click', execute);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        this.$jQuery(pin_text.pinText).on('click', execute);
                    }

                    this.$jQuery(btn_close).on('click', () => {
                        bitmap && occ_modal.removeChild(bitmap);

                        _this_current.children = children_temp;

                        occ_modal_background.visible = false;

                        btn_close.visible = false;
                    });
                } else {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(false);
                    pin.setAction(false, 'default', null);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(false);
                        pin_text.setAction(false, 'default', null);
                    }
                }
                /**
                 * Clone pin
                 */
                content_plant.occ_pins.addChild(pin.pin);

                /**
                 * Clone pin text
                 */
                if (!this.isIdCompound(_id)) {
                    Y += pin_text_default_y;
                    count += 1;

                    if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                        if (total && total >= count) {
                            _this_current[`content_text_${current_frame}${frame_keys[letter]}`].addChild(pin_text.pinText);
                        }
                    }
                }

                if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                    if (total && total === count) {
                        Y = 0;
                        letter += 1;
                    }
                }

                next(true);
            });
        });
    };

    /**
     *
     * @param document
     * @param current_name
     * @param array
     */
    createPaginate = (document, current_name, array) => {
        const {uri} = this.state;

        let pages = [];

        this.setAppCssIFrame(document, 'level_two');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let
                    button = this.verifyField(item, 'button'),
                    page_default = this.verifyField(item, 'page_default');

                if (page_default) {
                    this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current_name}/${name}/${name}.html`);
                }

                if (button) {
                    !button.startsWith('btn_') && (button = `btn_${button}`);

                    pages.push({
                        button: button,
                        listener: () => {
                            this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current_name}/${name}/${name}.html`);
                        }
                    });
                }

                next(true);
            } else {
                stop(true);
            }
        }, () => {
            this.setState({...this.state, [`_this_${current_name}_paginates`]: pages});
        });
    };

    /**
     *
     * @param current_name
     * @param paginate_name
     */
    getPaginate = (current_name, paginate_name) => {
        const
            _this_current = this.state[`_this_${current_name}`],
            _this_paginates = this.state[`_this_${paginate_name}_paginates`];

        this.recursiveSyncMap(_this_paginates, 0, _this_paginates.length, (item, next, stop) => {
            if (this.isObjectIf(item)) {
                let button = item.button;
                if (typeof (_this_current[button]) !== 'undefined') {
                    !this.verifyField(_this_current[button], '_listeners.click') && _this_current[button].addEventListener('click', item.listener);
                }
                next(true);
            } else {
                stop(true);
            }
        });
    };

    /**
     *
     * @param _this
     * @returns {{reference(*): void, setCoordinate(*): void, sun, object: null}|null}
     */
    reference = (_this) => {
        return {
            object: null,

            /**
             *
             * @returns {null}
             */
            get sun() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set sun(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            reference(name) {
                const _this_current = _this.state[`_this_${name}`], {
                    occ_sun,
                    parent: {input_slider}
                } = _this_current;
                this.sun = {sun: occ_sun, input: input_slider};
            },

            /**
             *
             * @param x
             */
            setCoordinate(x) {
                const {sun, sun: {occ_plant_light}, input: {content_tracker: {btn_slider}}} = this.object;
                x = _this.toIntegerOrFloat(x);
                if (_this.isIntegerOrFloat(x)) {
                    let frame = _this.toInteger(x);
                    // if (frame <= 60) {
                    //     let
                    //         big_bright_start = (new Big(0.35)),
                    //         big_bright = _this.$controller.big_100.div(new Big(6000)).times(frame);
                    //
                    //     if (big_bright.gte(big_bright_start) && big_bright.lte(new Big(1))) {
                    //         let bright = big_bright.round(2, Big.roundUp).toNumber();
                    //         occ_plant_light.filters = [(new _this.$createJs.ColorFilter(bright, bright, bright, 1, 0, 0, 0, 0))];
                    //         occ_plant_light.cache(-2,-2,868,644);
                    //     }
                    // } else {
                    //     occ_plant_light.filters = [(new _this.$createJs.ColorFilter(1, 1, 1, 1, 0, 0, 0, 0))];
                    // }
                    _this.throttle('occ-plant-light-cache', () => {
                        const {x, y, width, height} = occ_plant_light.bitmapCache;
                        occ_plant_light.cache(x, y, width, height);
                    }, 200);

                    sun.gotoAndStop(frame);
                    btn_slider.setTransform(x);
                }
            }
        }
    };

    /**
     *
     * @param reference
     */
    syncHours = (reference) => {
        const
            {frame_min, frame_plus, frame_max} = this.props,
            plus = (new Big(frame_plus));

        let
            current = frame_min,
            frame = (new Big(frame_min));

        switch (this.$hours) {
            case 7:
                current = 50;
                break;
            case 8:
                current = 100;
                break;
            case 9:
                current = 150;
                break;
            case 10:
                current = 200;
                break;
            case 11:
                current = 250;
                break;
            case 12:
                current = 300;
                break;
            case 13:
                current = 350;
                break;
            case 14:
                current = 400;
                break;
            case 15:
                current = 450;
                break;
            case 16:
                current = 500;
                break;
            case 17:
                current = 550;
                break;
        }

        (this.$hours <= 6) && (current = 1);
        (this.$hours >= 18) && (current = frame_max);

        this.$createJs.Ticker.timingMode = this.$createJs.Ticker.RAF;

        let max = (new Big(current));

        const execute = () => {
            frame = frame.plus(plus);
            reference.setCoordinate(frame.round(1, Big.roundUp).toNumber());
            frame.gte(max) && this.$createJs.Ticker.removeEventListener('tick', execute);
        };

        this.$createJs.Ticker.addEventListener('tick', execute);
    };

    $functions = {
        btnSliderMouseDown: function () {
            const {data: {_stage, btn_slider}} = _this.getListener('create-sun-mousedown');

            let
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_x = (new Big(btn_slider.x));

            btn_slider.big_offsetX = big_mouseX.div(big_scaleX).minus(big_x);
        },
        btnSliderPressMove: function () {
            const
                {frame_min, frame_max} = _this.props,
                {data: {_stage, btn_slider, reference}} = _this.getListener('create-sun-pressmove');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_max = (new Big(frame_max)),
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_position = big_mouseX.div(big_scaleX).minus(btn_slider.big_offsetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max)) {
                reference.setCoordinate(big_position.round(1, Big.roundUp).toNumber());
            }
        },
        /**
         *
         * @param event
         */
        canvasExtractPosition: function (event) {
            (event.type === 'touchmove') && event.preventDefault();
            const
                {frame_min, frame_plus, frame_max, position_padding} = _this.props,
                {data: {properties, input, reference}} = _this.getListener('create-sun-touchstart');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_plus = (new Big(frame_plus)),
                big_frame_max = (new Big(frame_max)),
                big_bounds_width = (new Big(input.nominalBounds.width)),
                big_position_padding = (new Big(position_padding)),
                big_input_x = (new Big(input.x)),
                big_width = _this.calcSize(properties.width, event.target.clientWidth, big_bounds_width.minus(big_position_padding).toNumber(), true),
                big_height = _this.calcSize(properties.height, event.target.clientHeight, input.nominalBounds.height, true),
                big_leftHorizontal = _this.calcSize(properties.width, event.target.clientWidth, big_input_x.plus(big_position_padding.div(_this.$controller.big_2)).toNumber(), true),
                big_topVertical = _this.calcSize(properties.height, event.target.clientHeight, input.y, true),
                big_rightHorizontal = big_leftHorizontal.plus(big_width),
                big_bottomVertical = big_topVertical.plus(big_height),
                big_positionX = (new Big(event.targetTouches[0].clientX)),
                big_positionY = (new Big(event.targetTouches[0].clientY)),
                //big_positionX = (new Big(event.clientX)),
                //big_positionY = (new Big(event.clientY)),
                big_positionTargetX = big_positionX.minus(big_leftHorizontal),
                //big_positionTargetY = big_positionY.minus(big_topVertical),
                big_position = big_bounds_width.minus(big_position_padding).div(big_width).times(big_positionTargetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max) && (big_positionX.gte(big_leftHorizontal) && big_positionX.lte(big_rightHorizontal)) && (big_positionY.gte(big_topVertical) && big_positionY.lte(big_bottomVertical))) {
                reference.setCoordinate((big_position.eq(big_frame_plus) ? big_frame_min : big_position.eq(big_frame_max.minus(big_frame_plus)) ? big_frame_max : big_position).round(1, Big.roundUp).toNumber());
            }
        }
    };

    /**
     *
     * @param _canvas
     * @param _stage
     * @param name
     * @param library
     */
    createSun = (_canvas, _stage, name, library = null) => {
        const
            reference = this.reference(this),
            {properties} = this.state[`_this_${(!this.isEmpty(library) ? library : name)}_library`];

        reference.reference(name);

        const {input, input: {content_tracker: {btn_slider}}} = reference.sun;

        this.syncHours(reference);

        this.$createJs.Touch.enable(_stage);
        _stage.mouseMoveOutside = true;
        _stage.preventSelection = true;

        let
            data_touch = {
                properties: properties,
                input: input,
                reference: reference
            },
            data_mouse = {
                _stage: _stage,
                btn_slider: btn_slider
            };

        this.removeListener('mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, () => {
            this.addListener(btn_slider, 'mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, false, data_mouse);
        });

        this.removeListener('pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, () => {
            this.addListener(btn_slider, 'pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, false, {
                ...data_mouse,
                reference: reference
            });
        });

        this.removeListener('touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, {passive: true}, data_touch);
        });

        this.removeListener('touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, false, data_touch);
        });
    };

    /**
     *
     * @type {function(*, *, *): void}
     */
    createGallery = ((window, current_name, legend) => {
        const
            {
                pin_text_default_font,
                pin_text_default_size,
                pin_text_default_weight
            } = this.props,
            _this_current = this.state[`_this_${current_name}`],
            {properties} = this.state[`_this_${current_name}_library`],
            {
                $JssorSlider$,
                $Jease$,
                $JssorBulletNavigator$,
                $JssorArrowNavigator$,
                $Jssor$
            } = window;

        this.$jQuery(() => {
            let slider = (new $JssorSlider$('slider_container', {
                $FillMode: 1,
                $AutoPlay: 0,
                $Idle: 4000,
                $PauseOnHover: 1,
                $ArrowKeyNavigation: 1,
                $SlideEasing: $Jease$.$OutQuint,
                $SlideDuration: 800,
                $MinDragOffsetToSlide: 20,
                $SlideSpacing: 0,
                $UISearchMode: 1,
                $PlayOrientation: 1,
                $DragOrientation: 1,
                $SlideWidth: properties.width,
                $BulletNavigatorOptions: {
                    $Class: $JssorBulletNavigator$,
                    $ChanceToShow: 2,
                    $SpacingX: 8,
                    $Orientation: 1
                },

                $ArrowNavigatorOptions: {
                    $Class: $JssorArrowNavigator$,
                    $ChanceToShow: 2
                }
            }));

            const ScaleSlider = () => {
                let bodyWidth = window.document.body.clientWidth;
                bodyWidth ? slider.$ScaleWidth(Math.min(bodyWidth, properties.width)) : $Jssor$.$Delay(ScaleSlider, 30);
                //slider.$ScaleHeight(_this.calcSize(properties.width, bodyWidth, properties.height, false));
            }

            this.$jQuery(window).bind('load', ScaleSlider);
            this.$jQuery(window).bind('resize', ScaleSlider);
            this.$jQuery(window).bind('orientationchange', ScaleSlider);

            ScaleSlider();

            if (legend) {
                const {occ_typology} = _this_current;
                occ_typology.y = occ_typology.y + 5;
                occ_typology.font = `${pin_text_default_weight} ${pin_text_default_size + 10}px '${pin_text_default_font}'`;

                /**
                 *
                 * @param index
                 * @param callback
                 */
                const getCurrentLegend = (index, callback) => {
                    callback(this.$jQuery(this.$jQuery(slider.$Elmt).find('.slider-container').children()[index + 1]).find('.legend > div').text());
                };

                /**
                 *
                 * @param legend
                 * @returns {string}
                 */
                const removeString = (legend) => {
                    const
                        string_00 = ['DA', 'DO', 'DAS', 'DOS'],
                        string_01 = 'PERSPECTIVA',
                        string_02 = 'ILUSTRADA',
                        string_03 = 'PRELIMINAR',
                        string_04 = 'ILUSTRATIVA';

                    let array = [
                        '\\.',
                        'SUJEITA A ALTERAÇÃO'
                    ];

                    for (let i = 0; i < string_00.length; i++) {
                        array.push(`${string_01} ${string_02} ${string_00[i]} `);
                        array.push(`${string_01} ${string_04} ${string_00[i]} `);
                        array.push(`${string_01} ${string_02} ${string_03} ${string_00[i]} `);
                        array.push(`${string_01} ${string_03} ${string_02} ${string_00[i]} `);
                    }

                    return legend.replace(new RegExp(array.join('|'), 'gi'), '').toUpperCase();
                };

                const changeLegend = (index) => {
                    getCurrentLegend(index, (legend) => {
                        occ_typology.text = removeString(legend);
                    });
                };

                changeLegend(slider.$CurrentIndex());

                slider.$On($JssorSlider$.$EVT_PARK, (slideIndex) => {
                    changeLegend(slideIndex);
                });
            }
        });
    });

    /**
     *
     * @param occurrence
     * @param color
     * @param width
     * @param speed
     * @returns {*}
     */
    spinner = (occurrence = {}, color = '#333333', width = 30, speed = 1.5) => {
        const movieClip = (new createjs.MovieClip({loop: -1}));
        movieClip.name = 'occ_spinner';

        let
            radius = (width / 10),
            circles = 20,
            radiant = ((Math.PI * 2) / circles),
            circumference_x = ((occurrence.nominalBounds.width - radius) / 2),
            circumference_y = ((occurrence.nominalBounds.height - radius) / 2),
            opacity = 1;

        for (let i = 0; i < circles; i++) {
            /* Calculate points on circumference. */
            let
                x = ((Math.cos(radiant * i) * width) + circumference_x),
                y = ((Math.sin(radiant * i) * width) + circumference_y);

            /* Draw circle on the point. */
            let circle = (new createjs.Shape(new createjs.Graphics().beginFill(color).drawCircle(x, y, radius)));

            /* Add animation. */
            movieClip.timeline.addTween(createjs.Tween.get(circle).to({alpha: opacity}).to({alpha: 0}, speed * i).to({alpha: opacity}, speed));
        }

        occurrence.addChild(movieClip);

        return movieClip;
    };
}

/**
 *
 * @type {{pin_default_color_enabled: Requireable<string>, frame_min: Requireable<number>, throttle_delay: Requireable<number>, marker_type: Requireable<string>, pin_text_default_size: Requireable<number>, content_text_pins: Requireable<object>, frame_max: Requireable<number>, alpha_min: Requireable<number>, pin_round_default_color: Requireable<string>, alpha_max: Requireable<number>, pin_default_color_disabled: Requireable<string>, position_padding: Requireable<number>, pin_text_default_weight: Requireable<string>, alpha_plus: Requireable<number>, pin_number_default_color: Requireable<string>, pin_text_default_font: Requireable<string>, ajax_setup_headers: Requireable<object>, _SOURCE_: Requireable<string>, frame_plus: Requireable<number>, pin_text_default_color: Requireable<string>, _TITLE_: Requireable<string>, _LOCATION_: Requireable<string>, pin_text_default_x: Requireable<number>, window: Requireable<object>, pin_text_default_y: Requireable<number>}}
 */
const propTypes = {
    _TITLE_: PropTypes.string,
    _LOCATION_: PropTypes.string,
    _SOURCE_: PropTypes.string,
    window: PropTypes.object,
    marker_type: PropTypes.oneOf(['arrow', 'strip']),
    position_padding: PropTypes.number,
    frame_min: PropTypes.number,
    frame_plus: PropTypes.number,
    frame_max: PropTypes.number,
    alpha_min: PropTypes.number,
    alpha_plus: PropTypes.number,
    alpha_max: PropTypes.number,
    throttle_delay: PropTypes.number,
    content_text_pins: PropTypes.object,
    pin_default_color_enabled: PropTypes.string,
    pin_default_color_disabled: PropTypes.string,
    pin_round_default_color: PropTypes.string,
    pin_text_default_x: PropTypes.number,
    pin_text_default_y: PropTypes.number,
    pin_text_default_color: PropTypes.string,
    pin_number_default_color: PropTypes.string,
    pin_text_default_font: PropTypes.string,
    pin_text_default_size: PropTypes.number,
    pin_text_default_weight: PropTypes.oneOf(['normal', 'bold']),
    ajax_setup_headers: PropTypes.object
};

/**
 *
 * @type {{default: {pin_default_color_enabled: string, frame_min: number, throttle_delay: number, marker_type: string, pin_text_default_size: number, content_text_pins: {frame_01: {A: number, B: number, C: number, D: number}}, frame_max: number, alpha_min: number, pin_round_default_color: string, alpha_max: number, pin_default_color_disabled: string, position_padding: number, pin_text_default_weight: string, alpha_plus: number, pin_number_default_color: string, pin_text_default_font: string, ajax_setup_headers: {Authorization: string}, _SOURCE_: string, frame_plus: number, pin_text_default_color: string, _TITLE_: string, _LOCATION_: null, pin_text_default_x: number, window: {}, pin_text_default_y: number}}}
 */
const config = {
    default: {
        _TITLE_: ':: FAMPAR ::',
        _LOCATION_: null,
        _SOURCE_: '',
        window: {},
        marker_type: 'arrow',
        position_padding: 60,
        frame_min: 0,
        frame_plus: 1,
        frame_max: 600,
        alpha_min: 0,
        alpha_plus: 0.1,
        alpha_max: 1,
        throttle_delay: 500,
        content_text_pins: {
            frame_01: {
                A: 21
            }
        },
        pin_default_color_enabled: '0x000000',
        pin_default_color_disabled: '0xCCCCCC',
        pin_round_default_color: '0x525151',
        pin_text_default_x: 140,
        pin_text_default_y: 34,
        pin_text_default_color: '0x525151',
        pin_number_default_color: '0x525151',
        pin_text_default_font: 'MontserratRegular',
        pin_text_default_size: 16,
        pin_text_default_weight: 'normal',
        ajax_setup_headers: {
            //'Authorization': 'Bearer 10|XQ9Fp64YNrPE1I73zEpGdxjy1ZaZHXL6a895fRoZ', /* Local */
            'Authorization': 'Bearer 2|pba5zowJrTcd7Hsq1eV7B1nI8UtdKpzH2NUphmWC' /* Web */
        }
    }
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersAllTap');
    return (new HelpersAllTap(defaultProps));
};